/**
 * URL base do servidor MCP (sem path de endpoint) — sempre via VITE_MCP_URL.
 * Ex.: http://mcp.portalpasi.com.br | http://localhost:3040 | /api/mcp (proxy Vite em dev)
 */
export function getMcpBaseUrl(): string {
  const base = (import.meta.env.VITE_MCP_URL || '').trim()
  if (!base) {
    throw new Error(
      'VITE_MCP_URL não configurada. Defina a URL base do MCP (ex.: http://mcp.portalpasi.com.br).',
    )
  }
  return base.replace(/\/+$/, '')
}

/** POST /chat — Cockpit Análise IA (SSE) */
export function getMcpChatUrl(): string {
  return `${getMcpBaseUrl()}/chat`
}

/** POST /flowchart/chat — assistente do canvas de fluxograma */
export function getMcpFlowchartChatUrl(): string {
  return `${getMcpBaseUrl()}/flowchart/chat`
}
